<div *ngIf="(viewModel.potencyScore$ | push: 'immediate') > 0" class="potency-container">
  <div class="potency-label">POTENCY</div>
  <div class="potency-score">
    <div
      *rxFor="let circle of viewModel.iterablePotencyScore$; strategy: 'immediate'"
      class="potency-point"
      [style.background-color]="viewModel.potencyScoreColor$ | push: 'immediate'"></div>
  </div>
</div>
